import {
    createWishlistItem,
    deleteWishlistItem,
    editWishlistItem,
    getWishlistItemById,
    getWishlistItems,
    getWishlistUpdatesCount,
    markWishlistSeen,
} from './wishlist.action';
export { wishlistReducer } from './wishlist.reducer';
export { watchWishlist } from './wishlist.saga';

export const wishlistActions = {
    getWishlistItems,
    getWishlistItemById,
    createWishlistItem,
    editWishlistItem,
    deleteWishlistItem,
    getWishlistUpdatesCount,
    markWishlistSeen,
};
